import { transformStepLabel } from 'utils/stepLabel';
import { change } from 'redux-form';
import {
  FormHandlingSection,
  FormSenderOverridesSection,
  DeviceFilterSection,
} from 'xm-constants/flowInput';
import { call } from '../xmAPI';

export const RESET_ENDPOINT_TYPE_CHANGED = 'RESET_ENDPOINT_TYPE_CHANGED';

export const FBI_SAVE = 'FBI_SAVE';

export const FBI_EDIT_START = 'FBI_EDIT_START';
export const FBI_EDIT_NODE_END = 'FBI_EDIT_NODE_END ';

export const FBI_FETCH_PLAN_CONSTANT = 'FBI_FETCH_PLAN_CONSTANT';
export const FBI_FETCH_PLAN_ENDPOINT = 'FBI_FETCH_PLAN_ENDPOINT';

export const FBI_FETCH_PLAN_CONSTANT_START = `${FBI_FETCH_PLAN_CONSTANT}_START`;
export const FBI_FETCH_PLAN_CONSTANT_SUCCESS = `${FBI_FETCH_PLAN_CONSTANT}_SUCCESS`;
export const FBI_FETCH_PLAN_CONSTANT_FAILURE = `${FBI_FETCH_PLAN_CONSTANT}_FAIL`;

export const FBI_FETCH_PLAN_ENDPOINT_START = `${FBI_FETCH_PLAN_ENDPOINT}_START`;
export const FBI_FETCH_PLAN_ENDPOINT_SUCCESS = `${FBI_FETCH_PLAN_ENDPOINT}_SUCCESS`;
export const FBI_FETCH_PLAN_ENDPOINT_FAILURE = `${FBI_FETCH_PLAN_ENDPOINT}_FAIL`;

export const FBI_FETCH_LAYOUT_FOR_CREATE_EVENT_INPUTS_UPDATE =
  'FBI_FETCH_LAYOUT_FOR_CREATE_EVENT_INPUTS_UPDATE';
export const FBI_FETCH_LAYOUT_FOR_CREATE_EVENT_INPUTS_UPDATE_SUCCESS = `${FBI_FETCH_LAYOUT_FOR_CREATE_EVENT_INPUTS_UPDATE}_SUCCESS`;

export const FBI_VALUE_CHANGED = 'FBI_VALUE_CHANGED';
export const FBI_ENDPOINT_SELECTED = 'FBI_ENDPOINT_SELECTED';
export const IB_ENDPOINT_CREATED = 'IB_ENDPOINT_CREATED';

export const FLOW_BLOCK_LABEL_CHANGED = 'FLOW_BLOCK_LABEL_CHANGED';
export const FLOW_BLOCK_ENVIRONMENT_CHANGED = 'FLOW_BLOCK_ENVIRONMENT_CHANGED';
export const FBI_EDIT_RESTORE_SAVED_INPUTS_AND_ENDPOINTS =
  'FBI_EDIT_RESTORE_SAVED_INPUTS_AND_ENDPOINTS';

export const FBI_EDIT_CHANGE_VERSION = 'FBI_EDIT_CHANGE_VERSION';
export const FBI_EDIT_REMOVED_DISMISSIBLE_WARNING =
  'FBI_EDIT_REMOVED_DISMISSIBLE_WARNING';

export const FBI_HTTP_TRIGGER_CHANGE_VERSION =
  'FBI_HTTP_TRIGGER_CHANGE_VERSION';
export const FBI_HTTP_TRIGGER_RESTORE_VERSION =
  'FBI_HTTP_TRIGGER_RESTORE_VERSION';

export const FBI_MERGE_BLOCK_COMMIT = 'FBI_MERGE_BLOCK_COMMIT';
export const FBI_MERGE_BLOCK_COMMIT_INPUTS_AND_OUTPUTS =
  'FBI_MERGE_BLOCK_COMMIT_INPUTS_AND_OUTPUTS';

export const FBI_VIEW_STATE_CUSTOM_PROP_SET = 'FBI_VIEW_STATE_CUSTOM_PROP_SET';

export function fetchPlanConstants(planId, type = FBI_FETCH_PLAN_CONSTANT) {
  return {
    type,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/plans/${planId}/constants?embed=usage`,
      method: 'getAll',
    },
  };
}

export function fetchPlanEndpoints(planId, type) {
  const url = type
    ? `/webapi/xm/1/plans/${planId}/endpoints?authenticationType=${type}`
    : `/webapi/xm/1/plans/${planId}/endpoints`;
  return {
    type: FBI_FETCH_PLAN_ENDPOINT,
    meta: {
      xmApi: true,
      uri: url,
      method: 'get',
    },
  };
}

export function fetchLayout(
  formId,
  type = FBI_FETCH_LAYOUT_FOR_CREATE_EVENT_INPUTS_UPDATE,
) {
  return {
    type,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/forms/${formId}/sections?embed=systemPropertyIds`,
      method: 'get',
    },
    payload: {
      formId,
    },
  };
}

export function startEditInput({
  flowBlockId,
  initialTab,
  onNotifyResponsesSubmit,
  scriptStepName,
  scriptStepType,
  scriptStepUuid,
  custom,
}) {
  return {
    type: FBI_EDIT_START,
    payload: {
      flowBlockId,
      name: scriptStepName,
      uuid: scriptStepUuid,
      scriptStepType,
      initialTab,
      onNotifyResponsesSubmit,
      custom,
    },
  };
}

export function onEndpointSelected(flowBlockId, endpointId) {
  return {
    type: FBI_ENDPOINT_SELECTED,
    payload: {
      flowBlockId,
      endpoint: { id: endpointId },
    },
  };
}

export function onFlowBlockInputChange(
  flowBlockId,
  scriptStepInputId,
  value,
  inputPort,
) {
  return {
    type: FBI_VALUE_CHANGED,
    payload: {
      flowBlockId,
      scriptStepInputId,
      value,
      inputPort,
    },
  };
}

export function setFlowBlockLabel({ flowBlockId, label }) {
  return {
    type: FLOW_BLOCK_LABEL_CHANGED,
    flowBlockId,
    label: transformStepLabel(label),
  };
}

export function endEditInput() {
  return {
    type: FBI_EDIT_NODE_END,
  };
}

export function restoreSavedUserInputsAndEndpoints() {
  return {
    type: FBI_EDIT_RESTORE_SAVED_INPUTS_AND_ENDPOINTS,
  };
}

export function save(flowBlockInput) {
  return {
    type: FBI_SAVE,
    data: flowBlockInput,
  };
}

export const resetEndpointTypeChanged = () => ({
  type: RESET_ENDPOINT_TYPE_CHANGED,
});

export function setBlockRunLocation(flowBlockId, runLocation) {
  return {
    type: FLOW_BLOCK_ENVIRONMENT_CHANGED,
    payload: {
      flowBlockId,
      environment: runLocation,
    },
  };
}

export const saveMergeStep = payload => ({
  type: FBI_MERGE_BLOCK_COMMIT,
  payload,
});

export const updateMergeStepInputsAndOutputs = payload => ({
  type: FBI_MERGE_BLOCK_COMMIT_INPUTS_AND_OUTPUTS,
  payload,
});

/*
 * URL Auth related GWT actions:
 */
export const INTEGRATION_URL_AUTH_USER_SEARCH =
  'INTEGRATION_URL_AUTH_USER_SEARCH';
export const INTEGRATION_URL_AUTH_USER_SEARCH_START = `${INTEGRATION_URL_AUTH_USER_SEARCH}_START`;
export const INTEGRATION_URL_AUTH_USER_SEARCH_SUCCESS = `${INTEGRATION_URL_AUTH_USER_SEARCH}_SUCCESS`;
export const INTEGRATION_URL_AUTH_USER_SEARCH_FAIL = `${INTEGRATION_URL_AUTH_USER_SEARCH}_FAIL`;

export const INTEGRATION_GET_API_KEY = 'INTEGRATION_GET_API_KEY';
export const INTEGRATION_GET_API_KEY_START = `${INTEGRATION_GET_API_KEY}_START`;
export const INTEGRATION_GET_API_KEY_SUCCESS = `${INTEGRATION_GET_API_KEY}_SUCCESS`;
export const INTEGRATION_GET_API_KEY_FAIL = `${INTEGRATION_GET_API_KEY}_FAIL`;

export const INTEGRATION_REGENERATE_SECRET = 'INTEGRATION_REGENERATE_SECRET';
export const INTEGRATION_REGENERATE_SECRET_START = `${INTEGRATION_REGENERATE_SECRET}_START`;
export const INTEGRATION_REGENERATE_SECRET_SUCCESS = `${INTEGRATION_REGENERATE_SECRET}_SUCCESS`;
export const INTEGRATION_REGENERATE_SECRET_FAIL = `${INTEGRATION_REGENERATE_SECRET}_FAIL`;

export const searchPeople = query => dispatch => {
  if (!window.XM_recipientSearch) return;

  window.XM_recipientSearch(query, +new Date());
  dispatch({
    type: INTEGRATION_URL_AUTH_USER_SEARCH_START,
  });
};

export const getPersonAPIKey = (integrationUuid, userId) => dispatch => {
  if (!window.XM_getApiKey) return;

  window.XM_getApiKey(integrationUuid, userId);
  dispatch({
    type: INTEGRATION_URL_AUTH_USER_SEARCH_START,
  });
};

export const regenerateSecret = (integrationUuid, userId) => dispatch => {
  if (!window.XM_regenerateSecret) return;

  window.XM_regenerateSecret(integrationUuid, userId);
  dispatch({
    type: INTEGRATION_REGENERATE_SECRET_START,
  });
};

/*
 * CREATE_EVENT related actions:
 */
export const FBI_SET_CREATE_EVENT_BLOCK_FORM_ID =
  'FBI_SET_CREATE_EVENT_BLOCK_FORM_ID';
export const setFlowBlockForm =
  ({ formId, flowBlockId, label }) =>
  dispatch => {
    dispatch({
      type: FBI_SET_CREATE_EVENT_BLOCK_FORM_ID,
      payload: { flowBlockId, formId, label },
    });
  };

/**
 * This createFormSections REAPI endpoint can throw 500s if called twice in parallel.
 * Odds are the API won't get fixed any time soon. As such adding a quick patch to
 * minimize these errors by essentially throttling the method by formId (i.e. so
 * multiple calls for the exact same formId within a couple seconds are grouped.)
 */
const createFormSectionsCache = {};
const CREATE_FORM_SECTION_THROTTLE = 3000; // milliseconds, so 3 seconds
const getRecentCreateFormSectionsCall = formId => {
  const lastCallData = createFormSectionsCache[formId];
  if (!lastCallData?.timestamp) return null;
  const timeSinceCall = new Date() - lastCallData.timestamp;
  return timeSinceCall > CREATE_FORM_SECTION_THROTTLE
    ? null
    : lastCallData.promise;
};

export const createFormSections = formId => dispatch => {
  const missingSections = {
    messagePanelId: formId,
  };
  missingSections.panelSections = [
    FormHandlingSection,
    FormSenderOverridesSection,
    DeviceFilterSection,
  ];

  const recentCallPromise = getRecentCreateFormSectionsCall(formId);
  if (recentCallPromise) {
    return recentCallPromise;
  }

  const promise = call('/rest/message-panels/panel-sections', {
    method: 'POST',
    body: JSON.stringify(missingSections),
  }).then(() => {
    dispatch(
      fetchLayout(formId, FBI_FETCH_LAYOUT_FOR_CREATE_EVENT_INPUTS_UPDATE),
    );
  });

  createFormSectionsCache[formId] = { promise, timestamp: new Date() };
  return promise;
};

export function changeVersion(version) {
  return (dispatch, getState) => {
    return new Promise(res => {
      dispatch({
        type: FBI_EDIT_CHANGE_VERSION,
        version,
      });

      const blockId =
        getState().flowBlockInput.integrationScriptStep.scriptStep.flowBlockId;
      const inputs = getState().flowDesigner.inputs.filter(
        i => i.flowBlock.id === blockId,
      );
      inputs.forEach(i => {
        const scriptStepId = i.scriptStepInput.id;
        const fieldName = `${blockId}|${scriptStepId}`;
        // ?? instead of || in case user specifically typed blank (""):
        const value = i.value ?? i.scriptStepInput.defaultValue;
        dispatch(change('FlowBlockInput', fieldName, value));
      });
      res();
    });
  };
}

export function removeDismissibleWarning() {
  return {
    type: FBI_EDIT_REMOVED_DISMISSIBLE_WARNING,
  };
}

export function changeHttpTriggerVersion(version) {
  return {
    type: FBI_HTTP_TRIGGER_CHANGE_VERSION,
    version,
  };
}

export function restoreHttpTriggerVersion() {
  return {
    type: FBI_HTTP_TRIGGER_RESTORE_VERSION,
  };
}

export function setViewStateCustomProp({ propName, value }) {
  return {
    type: FBI_VIEW_STATE_CUSTOM_PROP_SET,
    payload: {
      propName,
      value,
    },
  };
}
